import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { COUNTRY } from "../../../constants/app";
import { Link, useNavigate } from "react-router-dom";
import { URLS } from "../../../constants/url";
import { setContentModal, toggleContentModal } from "../../../store/application/action";
import { ROUTES } from "../../../constants/path";
import './footer.scss';
import { socialMediaUrl } from "../../../utils/helper";


interface footerInterface { }

const Footer: FC<footerInterface> = () => {

    const {
        countryId,
    } = useSelector((state: RootState) => ({
        countryId: state.applicationReducer.countryId as COUNTRY,
    }));

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [facebookUrl, setFacebookUrl] = useState<string>("");
    const [instagramUrl, setInstagramUrl] = useState<string>("");
    const [tiktokUrl, setTiktokUrl] = useState<string>("");


  useEffect(() => {
    if (countryId) {
      const { facebook, instagram, tiktok } = socialMediaUrl(countryId);
      setFacebookUrl(facebook);
      setInstagramUrl(instagram);
      setTiktokUrl(tiktok)
    }
  }, [countryId]);
 
    const openModal = (type: string) => {
        dispatch(setContentModal({ type }));
        dispatch(toggleContentModal(true));
      };
    


    return  <div className="member-footer-top">
    <div className="footer-top">
      <div className="footer-top-inner">
        <ul>
          <li>
            <a
              href="javascript:void(0)"
              onClick={() => openModal(ROUTES.REELCLUB_TERMS)}
            >
              TERMS
            </a>
          </li>
          <li>
            <a
              href="javascript:void(0)"
              onClick={() => navigate(`/${ROUTES.FAQ}`)}
            >
              FAQs
            </a>
          </li>
          <li>
            <a
              href="javascript:void(0)"
              onClick={() => openModal(ROUTES.CONTACT_US)}
            >
              CONTACT US
            </a>
          </li>
          <li>
            <a
              href="javascript:void(0)"
              onClick={() =>
                navigate(`/${ROUTES.MOVIES}/${ROUTES.NOW_SHOWING}`)
              }
            >
              CINEMA HOMEPAGE
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="sm">
      <Link to={facebookUrl} target="_blank">
        <img src={URLS.FACEBOOK_ICON_WHITE} />
      </Link>
      <Link to={instagramUrl} target="_blank">
        <img src={URLS.INSTAGRAM_ICON_WHITE} />
      </Link>
      {tiktokUrl?<Link to={tiktokUrl} target="_blank">
        <img src={URLS.TIKTOK_ICON} />
      </Link>:null}
    </div>
  </div>
}

export default Footer;